/* eslint-disable */
import React, { useState } from "react";
import { Drawer, Button, DatePicker, Form, Input, Select, InputNumber, Badge } from "antd";
import { FORMAT_FOR_DATE_WITH_TIME } from "../../constants/constants";
import { PURCHASE_SOURCES, BALANCE_STATUSES } from "eurst-shared/src/enums";
import MinMaxFormField from "../../components/MinMaxFormField";
import { getFilledInObject } from "../../utils/helpers";

const { RangePicker } = DatePicker;
const { Option } = Select;

function PurchaseFilter({ onSubmit, onReset, loading }) {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [count, setCount] = useState(0);

  const filtersFilled = () => {
    const values = form.getFieldsValue();

    const count = getFilledInObject(values);

    setCount(count);
  };

  const onChange = (name, value) => {
    form.setFieldsValue({ [name]: value });
  };

  const onFiltersReady = (values) => {
    let created = {};
    if (values.createdAt && values.createdAt.length > 0) {
      created.createdAtFrom = values.createdAt[0].toISOString();
      created.createdAtTo = values.createdAt[1].toISOString();
    }
    onSubmit({
      ...values,
      ...created,
    });

    filtersFilled();

    onClose();
  };

  const onClearFilter = () => {
    form.resetFields();

    onReset({});

    filtersFilled();

    onClose();
  };

  const onClose = () => {
    setVisible(false);
  };

  if (!visible) {
    return (
      <React.Fragment>
        <Badge count={count}>
          <Button type="primary" onClick={() => setVisible(true)}>
            Filter
          </Button>
        </Badge>
        <Button disabled={loading} onClick={onClearFilter}>
          Reset
        </Button>
      </React.Fragment>
    );
  }
  return (
    <Drawer visible={visible} title="Search transactions" width={400} onClose={onClose}>
      <Form
        form={form}
        name="filter"
        style={{ height: "100%", textAlign: "left" }}
        layout={"vertical"}
        onFinish={onFiltersReady}
        initialValues={{}}
        scrollToFirstError>
        <Form.Item name="createdAt" label="Date">
          <RangePicker
            inputReadOnly
            format={FORMAT_FOR_DATE_WITH_TIME}
            // onChange={(dates) => {
            //   if (!dates || dates.length === 0) return
            //   onChange('createdAtFrom', dates[0])
            //   onChange('createdAtTo', dates[0])
            // }}
            style={{ width: 250, marginBottom: 8 }}
          />
        </Form.Item>
        <Form.Item label="User email" name="userEmail">
          <Input />
        </Form.Item>

        <MinMaxFormField
          nameMin="eurAmountFrom"
          label="EURST amount from - to"
          nameMax="eurAmountTo"
          onChange={onChange}
        />

        <MinMaxFormField
          nameMin="amountFrom"
          label="USD amount from - to"
          nameMax="amountTo"
          onChange={onChange}
        />

        <Form.Item label="Payment method" name="source">
          <Select value={form.getFieldsValue("source")}>
            {PURCHASE_SOURCES.map((type) => {
              return (
                <Option key={type.id} label={type.label} value={type.id}>
                  {type.label}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item label="Status" name="status">
          <Select onChange={(value) => onChange("status", value)}>
            {Object.keys(BALANCE_STATUSES).map((type) => {
              return (
                <Option
                  key={BALANCE_STATUSES[type].id}
                  label={BALANCE_STATUSES[type].label}
                  value={type.id}>
                  {BALANCE_STATUSES[type].label}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item label="Reference" name="trnHash">
          <Input onChange={(ev) => onChange("trnHash", ev.target.value)} />
        </Form.Item>

        <Button type="primary" loading={loading} htmlType="submit">
          Search
        </Button>
        <Button loading={loading} onClick={onClearFilter}>
          Reset
        </Button>
      </Form>
    </Drawer>
  );
}

export default PurchaseFilter;
